import { createReducer } from 'reduxsauce';
import { COMPANY_ONBOARDING } from 'actions/Base';

export const INITIAL_STATE = {
  companyIsFinished: false,
  companyUserIsFinished: false
};

export const onCreateCompanyUserRequest = (state) => ({ ...state, companyUserIsFinished: false });
export const onCreateCompanyUserFailure = (state) => ({ ...state, companyUserIsFinished: false });
export const onCreateCompanyUserSuccess = (state, { payload }) => ({ ...state, companyUserIsFinished: true, instance: payload });

export const onCreateCompanyRequest = (state) => ({ ...state, companyIsFinished: false });
export const onCreateCompanyFailure = (state) => ({ ...state, companyIsFinished: false });
export const onCreateCompanySuccess = (state, { payload }) => ({ ...state, companyIsFinished: true, instance: payload });

export const ACTION_HANDLERS = {
  [COMPANY_ONBOARDING.CREATE_COMPANY_USER_REQUEST]: onCreateCompanyUserRequest,
  [COMPANY_ONBOARDING.CREATE_COMPANY_USER_FAILURE]: onCreateCompanyUserFailure,
  [COMPANY_ONBOARDING.CREATE_COMPANY_USER_SUCCESS]: onCreateCompanyUserSuccess,

  [COMPANY_ONBOARDING.CREATE_COMPANY_REQUEST]: onCreateCompanyRequest,
  [COMPANY_ONBOARDING.CREATE_COMPANY_FAILURE]: onCreateCompanyFailure,
  [COMPANY_ONBOARDING.CREATE_COMPANY_SUCCESS]: onCreateCompanySuccess, 
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
